// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });

    /*Tiny slider pecas*/
    const tnsSliderMultipleRound = document.querySelectorAll('.-multiple-round-tns');
    tnsSliderMultipleRound.forEach(sliderRound => {
      const tnsSliderM = tns({
           container: sliderRound,
           items: 1,
           nav: false,
           /*gutter: 20,*/
           autoplayButtonOutput: false,
           autoplay: false,
           controlsPosition: "bottom",
           controlsText: ['<span class="-arrow -arrow-prev icon-arrow-left"></span>', '<span class="-arrow -arrow-next icon-arrow-right"></span>'],
           /*controlsText: ['<span class="iconify" data-icon="bi:chevron-left"></span>', '<span class="iconify" data-icon="bi:chevron-right"></span>'],*/
           loop: false,
           swipeAngle: false,
           responsive: {     
              320: {
                /*items: 1,
                controls: false,
                fixedWidth: 380,*/
                /*gutter: 24,*/
                mouseDrag: true,
                nav: false,
                controls: false,

                loop: false,
                swipeAngle: false,
                items: 1.2,
                /*autoplay: true,*/
                autoplayTimeout: 4000,
                //gutter: 24,
              },
              768: {
                items: 2,
                nav: true,
                controls: false,
              },
              900: {
                items: 3,
                nav: false,
                controls: true,
              },
              1025: {
                gutter: 30,
                //loop: false,
                /*swipeAngle: false,
                items: 5.4,*/

                /*fixedWidth: 545,
                loop: true,
                swipeAngle: true,*/
                /*gutter: 18,*/
                //mouseDrag: true,
              },

            }
      });
    });

    /*Tiny slider sinple*/
    const tnsSliderSimple = document.querySelectorAll('.-simple-tns');
    tnsSliderSimple.forEach(sliderSimple => {
      const tnsSliderSp = tns({
           container: sliderSimple,
           items: 1,
           nav: true,
           controls: false,
           autoplayButtonOutput: false,
           autoplay: true,
           autoplayTimeout: 4000,
           controlsPosition: "bottom" 
      });
    });



    /*Tiny slider sponsor*/
    const tnsSponsor = document.querySelector('.-sc-sponsor-tns');
    if (tnsSponsor) {
      const tnsSlider = tns({
        container: tnsSponsor,
        /*items: 1,*/
        mouseDrag: true,
        nav: false,
        controls: false,
        /*gutter: 20,*/
        autoplayButtonOutput: false,
        autoplay: false,
        controlsPosition: "bottom",
        loop: false,
        swipeAngle: false,
        responsive: {     
          320: {
            /*items: 1,
            nav: false,
            controls: false,*/
            

            /*fixedWidth: 298,
            gutter: 24,
            mouseDrag: true,*/


            loop: false,
            swipeAngle: false,
            items: 1.4,
            gutter: 24,
          },
          768: {
            /*items: 2,
            nav: true,
            controls: false,*/
          },
          900: {
            /*items: 3,
            nav: false,
            controls: true,*/
          }
}


      });   
    
    }    

    /*Tiny slider interviews*/
    const tnsInterviews = document.querySelector('.-sc-interviews-tns');
    if (tnsInterviews) {
      const tnsSlider = tns({
        container: tnsInterviews,
        /*items: 1,*/
        mouseDrag: true,
        nav: true,
        controls: false,
        /*gutter: 20,*/
        autoplayButtonOutput: false,
        autoplay: false,
        controlsPosition: "bottom",
        loop: false,
        swipeAngle: false,
        responsive: {     
          320: {
            /*nav: false,
            controls: false,*/
            loop: false,
            swipeAngle: false,
            items: 5.4,

            //fixedWidth: 74,
            /*gutter: 18,*/
            mouseDrag: true,
          },
          768: {
            /*items: 2,
            nav: true,
            controls: false,*/
          },
          900: {
            /*items: 3,
            nav: false,
            controls: true,*/
          },
          1025: {
            items: 6,
          },

}


      });   
    
    }

    /*Tiny slider interviews*/
    const tnsInterviewsFive = document.querySelector('.-sc-interviews-tns-five');
    if (tnsInterviewsFive) {
      const tnsSlider = tns({
        container: tnsInterviewsFive,
        /*items: 1,*/
        mouseDrag: true,
        nav: true,
        controls: false,
        /*gutter: 20,*/
        autoplayButtonOutput: false,
        autoplay: false,
        controlsPosition: "bottom",
        loop: false,
        swipeAngle: false,
        responsive: {     
          320: {
            /*nav: false,
            controls: false,*/
            loop: false,
            swipeAngle: false,
            items: 5,

            //fixedWidth: 74,
            /*gutter: 18,*/
            mouseDrag: true,
          },
          768: {
            /*items: 2,
            nav: true,
            controls: false,*/
          },
          900: {
            /*items: 3,
            nav: false,
            controls: true,*/
          }
}


      });   
    
    }    

    /*Tiny slider columns*/
    const tnsColumns = document.querySelector('.-columns-tns');
    if (tnsColumns) {
      const tnsSlider = tns({
        container: tnsColumns,
        /*items: 1,*/
        mouseDrag: true,
        nav: true,
        controls: false,
        /*gutter: 20,*/
        autoplayButtonOutput: false,
        autoplay: false,
        controlsPosition: "bottom",
        loop: false,
        swipeAngle: false,
        responsive: {     
          320: {
            /*nav: false,
            controls: false,*/
            loop: false,
            swipeAngle: false,
            //items: 5.4,

            fixedWidth: 92,
            /*gutter: 18,*/
            mouseDrag: true,
          },
          768: {
            /*items: 2,
            nav: true,
            controls: false,*/
          },
          1025: {
            items: 6,
            fixedWidth: false,
            /*nav: false,
            controls: true,*/
          }
        }


      });   
    
    }  

    /*Tiny slider partners*/
    const tnsPartners = document.querySelector('.-sc-partners-tns');
    if (tnsPartners) {
      const tnsSlider = tns({
        container: tnsPartners,
        items: 3,
        mouseDrag: true,
        nav: false,
        controls: false,
        /*gutter: 20,*/
        autoplayButtonOutput: false,
        autoplay: false,
        controlsPosition: "bottom",
        /*loop: false,
        swipeAngle: false,*/
        responsive: {     
          320: {
            /*nav: false,
            controls: false,*/
            //fixedWidth: 74,
            /*gutter: 18,*/
            mouseDrag: true,
            autoplay: true,
            autoplayTimeout: 4000,
          },
          768: {
            items: 3,
            /*items: 2,
            nav: true,
            controls: false,*/
          },
          900: {
            /*items: 3,
            nav: false,
            controls: true,*/
          }
}


      });   
    
    }            

    /*Tiny slider pecas interest related*/
    const tnsSliderMultipleSquare = document.querySelectorAll('.-multiple-square-tns');
    tnsSliderMultipleSquare.forEach(sliderSquare => {
      const tnsSliderM = tns({
           container: sliderSquare,
           items: 1,
           nav: false,
           /*gutter: 20,*/
           autoplayButtonOutput: false,
           autoplay: false,
           controlsPosition: "bottom",
           controlsText: ['<span class="iconify" data-icon="bi:chevron-left"></span>', '<span class="iconify" data-icon="bi:chevron-right"></span>'],
           loop: false,
           swipeAngle: false,
           responsive: {     
              320: {
                /*items: 1,
                controls: false,
                fixedWidth: 380,*/
                /*gutter: 24,*/
                mouseDrag: true,
                nav: false,
                controls: false,

                loop: false,
                swipeAngle: false,
                items: 1.33,
                /*autoplay: true,*/
                autoplayTimeout: 4000,
                //gutter: 24,
              },
              768: {
                items: 2,
                nav: true,
                controls: false,
              },
              900: {
                items: 3,
                nav: false,
                controls: true,
              }
            }
      });
    });

    
   

    /*Trigger notice close*/
    $('.-toggle-address').click(function(e){
      e.preventDefault();
      $(this).closest('address').toggleClass('-open');
      /*console.log('cloner')*/
    });

    /*data filters*/
    $('[data-fill]').click(function(e) {
        e.preventDefault();
        var toggleVal = $(this).data('fill');
        var dataParent = $(this).closest('[data-filters]');
        var parent = $('#'+dataParent.data('filters'));

        dataParent.find('button').removeClass('active');
        $(this).addClass('active');
        
        if (toggleVal == '*') {
          parent.find('[data-filter]').removeClass('-fill-on');
          parent.find('[data-filter]').removeClass('-fill-off');
        }else{
          parent.find('[data-filter]').removeClass('-fill-on');
          parent.find('[data-filter]').addClass('-fill-off');
          parent.find('[data-filter="'+toggleVal+'"]').addClass('-fill-on');
        }
    });    

    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });

    /*content tabs*/
    $('.nav-tab-btn').click(function(){
      event.preventDefault();
      var tabTarget = $(this).data('tab');
      /*console.log(tabTarget);*/
      $(this).closest('.tabs-wrap').find('.tabs-content').removeClass('-visible');
      $(this).closest('.tabs-wrap').find('.tabs-content#'+tabTarget).addClass('-visible');
      $(this).closest('.tabs-wrap').find('.nav-tab-btn').removeClass('-active');
      $(this).addClass('-active');
    });

    /*Dropdown mobile*/
    $('.tabs-nav-btn').click(function(){
      event.preventDefault();
      var tabTarget = $(this).data('tab');
      //console.log(tabTarget);
      
      $('.tabs-content').removeClass('-visible');
      $('.tabs-content#'+tabTarget).addClass('-visible');
      $('.tabs-nav-btn').removeClass('-active');
      $(this).addClass('-active');


      /*if ($(window).width() < 769) {
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }*/
    });

    //password view trigger each
    var togglePassView = document.getElementsByClassName("togglePasswordClass");
    
    var toggleVisibleClass = function() {
      var closer = this.closest('.relative');
      var passwordField = closer.querySelector('input.view-pass'); 
      var type = passwordField.getAttribute("type") === "password" ? "text" : "password";
      passwordField.setAttribute("type", type);

      // toggle the icon
      closer.classList.toggle("hidden");
    };

    for (var i = 0; i < togglePassView.length; i++) {
        togglePassView[i].addEventListener('click', toggleVisibleClass, false);
    }

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      event.preventDefault();
      if ($(window).width() < 769) {
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }
    });

    $(function(){
      // bind change event to select
      $('.dynamic-select').on('change', function () {
          var url = $(this).val(); // get selected value
          if (url) { // require a URL
              window.location = url; // redirect
          }
          return false;
      });
    });

    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }

    //filter trigger
    var filterTrigger = document.getElementsByClassName("filter-trigger-btn");
    
    var toggleFilter = function() {
        console.log('main filter offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("filter-active");
    };

    for (var i = 0; i < filterTrigger.length; i++) {
        filterTrigger[i].addEventListener('click', toggleFilter, false);
    }


    //Offcanvas Form trigger
    var searchTrigger = document.getElementsByClassName("search-trigger-btn");
    
    var toggleCanvasForm = function() {
        document.body.classList.toggle("search-active");
    };

    for (var i = 0; i < searchTrigger.length; i++) {
        searchTrigger[i].addEventListener('click', toggleCanvasForm, false);
    }

    /*Anchor scroll in nav*/
    const navAnchors = document.querySelectorAll(".anchor > a");
     
    for (const anchorNav of navAnchors) {
      anchorNav.addEventListener("click", clickHandler);
    }

    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href");
      const offsetTop = document.querySelector(href).offsetTop;
      document.body.classList.remove("menu-active");
     
      scroll({
        top: offsetTop-header,
        behavior: "smooth"
      });
    }


    document.addEventListener('scroll', function(e) {
      lastKnownScrollPosition = window.scrollY;
      WindowWidth = window.innerWidth;
      //console.log(lastKnownScrollPosition);
      wHeight = window.innerHeight;
      mainHeader = document.getElementById('dynamic-header');
      Bodyclasses = document.body.getAttribute('class').split(' ');

      if (mainHeader) { 
       /* if (mainHeader.classList.contains('md-header-blog')) {
          var compareHeight = 60;
        }else{
          var compareHeight = wHeight/3;
        }*/
        var compareHeight = 60;

        if (lastKnownScrollPosition >= compareHeight ) {
          mainHeader.classList.add('-scrolled');
        }else{
          mainHeader.classList.remove('-scrolled');
        }
        
      }
      /*if (WindowWidth < 768 && Bodyclasses.indexOf('-fix-mobile') > -1) {
        e.preventDefault();
        window.scrollTo(0, 0);
      }*/

      /*if (!ticking) {
        window.requestAnimationFrame(function() {
          doSomething(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }*/
    });



    /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) {
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('lgpd_cookie_accept');/*Name of cookie*/
          //console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('lgpd_cookie_accept', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('lgpd_cookie_accept', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('lgpd_cookie_accept', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    });

    //Function to redirect form after submit
    /*document.addEventListener( 'wpcf7mailsent', function( event ) {
        switch (event.detail.contactFormId ) {
            case '15':
                location = 'http://www./';
                break; 
            default: 
                
        }
    }, false );*/
    //End
    

    /*Input Masks*/
    function runmask() {
      v_obj.value=v_fun(v_obj.value);
    }

    function mask(o,f) {
      v_obj=o;
      v_fun=f;
      setTimeout(runmask(),1)
    }

    function mtel(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
      v = v.replace(/(\d)(\d{4})$/, "$1-$2");
      return v;
    }

    function modate(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "$1/$2");
      v = v.replace(/(\d)(\d{4})$/, "$1/$2");
      return v;
    }

    function mnumbers(v) {
      v = v.replace(/\D/g, "");
      return v;
    }
    function mcep(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{5})(\d)/g, "$1-$2");
      return v;
    }
    function price(v) {
        /*v = v.replace(/\D/g, "");
        v = v.replace(/([0-9]{2})$/g, ",$1");
        v = v.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        v = v.replace(/([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2,$3");
        v = v.replace(/([0-9]{3}).([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2.$3,$4");
        return v;*/
        v = v + '';
        v = parseInt(v.replace(/[\D]+/g, ''));
        v = v + '';
        v = v.replace(/([0-9]{2})$/g, ",$1");

        if (v.length > 6) {
            v = v.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        }

        if(v == 'NaN') v = '';
        return v;
    }

    function mCpf(v){
      //Remove tudo o que não é dígito
      v=v.replace(/\D/g,"")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{3})(\d)/,"$1.$2")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      v=v.replace(/(\d{3})(\d)/,"$1.$2")

      //Coloca um hífen entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")

      return v  
    }

    function cpfCnpj(v){
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g,"");
     
        if (v.length < 14) { //CPF   405.604.628-08  43.201.151/0001-99
     
            //Coloca um ponto entre o terceiro e o quarto dígitos
            v=v.replace(/(\d{3})(\d)/,"$1.$2")
     
            //Coloca um ponto entre o terceiro e o quarto dígitos
            //de novo (para o segundo bloco de números)
            v=v.replace(/(\d{3})(\d)/,"$1.$2")
     
            //Coloca um hífen entre o terceiro e o quarto dígitos
            v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
     
        } else { //CNPJ
            //console.log('aki');
            //Coloca ponto entre o segundo e o terceiro dígitos
            v=v.replace(/^(\d{2})(\d)/,"$1.$2")
     
            //Coloca ponto entre o quinto e o sexto dígitos
            v=v.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")
     
            //Coloca uma barra entre o oitavo e o nono dígitos
            v=v.replace(/\.(\d{3})(\d)/,".$1/$2")
     
            //Coloca um hífen depois do bloco de quatro dígitos
            v=v.replace(/(\d{4})(\d)/,"$1-$2")
     
        }
     
        return v
     
    }
    function maskCC(v){
      //Coloca um ponto entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{4})(\d)/,"$1 $2")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      v=v.replace(/(\d{4})(\d)/,"$1 $2")

      //Coloca um hífen entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{4})(\d{1,2})$/,"$1 $2")

      /*v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
      v = v.replace(/(\d)(\d{4})$/, "$1-$2");*/
      return v;

    }

    var cepValidator = document.getElementsByClassName('mask-cep');
    var cpfValidator = document.getElementsByClassName('mask-cpf');
    var telValidator = document.getElementsByClassName('mask-tel');
    var dateValidator = document.getElementsByClassName('mask-date');
    var priceValidator = document.getElementsByClassName('mask-price');
    var documentValidator = document.getElementsByClassName('mask-doc');
    var onlyNumbers = document.getElementsByClassName('mask-num');
    var ccMask = document.getElementsByClassName('mask-cc-num');

    if(ccMask && ccMask.length != -1){
      for (i = 0; i < ccMask.length; i++) {
        ccMask[i].addEventListener('keyup', function() {
          mask(this, maskCC);
        });
      }
    }
   
    if(onlyNumbers && onlyNumbers.length != -1){
      for (i = 0; i < onlyNumbers.length; i++) {
        onlyNumbers[i].addEventListener('keyup', function() {
          mask(this, mnumbers);
        });
      }
    }

    if(cepValidator && cepValidator.length != -1){
      for (i = 0; i < cepValidator.length; i++) {
        cepValidator[i].addEventListener('keydown', function() {
          mask(this, mcep);
        });
      }
    }
    if(cpfValidator && cpfValidator.length != -1){
      for (i = 0; i < cpfValidator.length; i++) {
        cpfValidator[i].addEventListener('keydown', function() {
          mask(this, mCpf);
        });
      }
    }
    if(telValidator && telValidator.length != -1){
      for (i = 0; i < telValidator.length; i++) {
        telValidator[i].addEventListener('keydown', function() {
          mask(this, mtel);
        });
      }
    }
    if(dateValidator && dateValidator.length != -1){
      for (i = 0; i < dateValidator.length; i++) {
        dateValidator[i].addEventListener('keyup', function() {
          mask(this, modate);
        });
      }
    }

    if(priceValidator && priceValidator.length != -1){
      for (i = 0; i < priceValidator.length; i++) {
        priceValidator[i].addEventListener('keyup', function() {
          mask(this, price);
        });
      }
    }

    if(documentValidator && documentValidator.length != -1){
      for (i = 0; i < documentValidator.length; i++) {
        documentValidator[i].addEventListener('keydown', function() {
          mask(this, cpfCnpj);
        });
      }
    }

    /*CEP autocomplete*/
    $(".cep-autocomplete").blur(function(){
        var address = $(this).closest('form').find(".endereco");
        var number = $(this).closest('form').find(".numero");
        var neighborhood = $(this).closest('form').find(".bairro");
        var city = $(this).closest('form').find(".cidade");
        var state = $(this).closest('form').find(".estado");
        var cep = this.value.replace(/[^0-9]/, "");
        if(cep.length != 8){
            return false;
        }        
        var url = "https://viacep.com.br/ws/"+cep+"/json/";
        $.getJSON(url, function(dadosRetorno){ /*console.log(dadosRetorno);*/
            try{
                address.val(dadosRetorno.logradouro);
                neighborhood.val(dadosRetorno.bairro);
                city.val(dadosRetorno.localidade);
                state.val(dadosRetorno.uf);
                number.focus();
            }catch(ex){}
        });
    });

    function plus_address(count){
        //console.log(count)
        let plus = parseInt(count)+1; 
        console.log(plus)
        let calculatorList = document.getElementById("distance-calculator");
        //calculatorList.innerHTML = '';

        var listItem = document.createElement('li');
        /*list.className = "-name";
        list.innerHTML = data["name"]; */

        var html = '';
        //html += '<li>';
          html += '<div class="-map-body-row col-12 col-md-6 -first">';
            html += '<mapbox-address-autofill>';
            html += '<input type="text" class="-map-zipcode" name="address" placeholder="INFORME SEU ENDEREÇO OU CEP" autocomplete="address-line1">';
            html += '</mapbox-address-autofill>';
            html += '<button type="button" class="-map-plus plus-distance" data-count="' + plus + '">+</button>';
          html += '</div>';

          html += '<div class="-map-body-row col-12 col-md-6 -last">';
            html += '<p class="-min map-distance" data-dist="' + plus + '">-</p>';
            html += '<p class="-large map-distance" data-timing="' + plus + '">-</p>';
          html += '</div>';
        //html += '</li>';

        listItem.innerHTML = html;  


        /*var locale = document.createElement('span');
        locale.className = "-locale";
        locale.innerHTML = '<i class="icon-pin"></i>'+data["event_locale"];*/ 

        /*var description = document.createElement('p');
        description.className = "-description";
        description.innerHTML = data["event_description"];*/

        calculatorList.appendChild(listItem);
    }    

    //$('.plus-distance').click(function(e){
    $('body').delegate('.plus-distance','click', function(e) {
      e.preventDefault();
      var count = $(this).attr('data-count');
      plus_address(count);
      loadplaceAutocomplete();
      /*$(this).closest('.-map-body').append;*/
      /*console.log('cloner')*/
    });

    window.addEventListener('load', function () {
      //$('#preloader').fadeOut();
      document.body.classList.remove('-pre-loader');
      var elementPreloader = document.getElementById('preloader');
      setTimeout(function(){
        document.body.classList.add('-pre-loader-off');
        /*if (elementPreloader) {
          elementPreloader.classList.add('off')
        }*/
      },3000);
      setTimeout(function(){
        document.body.classList.add('-pre-loader-end');
        /*if (elementPreloader) {
          elementPreloader.classList.add('off')
        }*/
      },5000);
    })



}(window.jQuery, window, document));